<template>
  <div :style="{ height: dynamicHeight + 'px' }">
    <BaseChart
      type="bar"
      :series="series"
      :categories="categories"
      :extraOptions="extraOptions"
    />
  </div>
</template>

<script>
import BaseChart from "./BaseChart.vue";

export default {
  name: "BarYesNoChart",

  components: {
    BaseChart,
  },

  props: {
    data: {
      type: Array,
      default: () => [],
    },
    horizontal: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: "binary_stacked",
    },
  },

  computed: {
    isScale() {
      return this.variant === "scale_mean_bar";
    },

    categories() {
      return this.data.map((item) => item.name);
    },

    scaleColors() {
      return this.data.map((item) => {
        const key = item?.classification?.key;

        if (key === "favorable") return "#22c55e";
        if (key === "risk") return "#ef4444";
        return "#f59e0b";
      });
    },

    series() {
      if (this.isScale) {
        return [
          {
            name: "Média",
            data: this.data.map((item) => item.mean ?? 0),
          },
        ];
      }

      return [
        {
          name: "Sim",
          data: this.data.map((item) => item.yes_percent ?? item.yes ?? 0),
        },
        {
          name: "Não",
          data: this.data.map((item) => item.no_percent ?? item.no ?? 0),
        },
      ];
    },

    extraOptions() {
      return {
        colors: this.isScale ? this.scaleColors : ["#22c55e", "#ef4444"],

        chart: {
          stacked: !this.isScale,
          toolbar: { show: false },
        },

        plotOptions: {
          bar: {
            horizontal: this.horizontal,
            barHeight: this.horizontal ? "60%" : undefined,
            columnWidth: this.horizontal ? undefined : "45%",
            borderRadius: 6,
            distributed: this.isScale,
          },
        },

        dataLabels: {
          enabled: false,
        },

        xaxis: {
          min: 0,
          max: this.isScale ? 5 : 100,
          categories: this.horizontal ? undefined : this.categories,
          labels: {
            formatter: (val) => {
              if (this.horizontal) {
                return this.isScale ? Number(val).toFixed(0) : `${val}%`;
              }

              return val;
            },
            style: {
              colors: "#94a3b8",
              fontSize: "12px",
            },
          },
        },

        yaxis: {
          categories: this.horizontal ? this.categories : undefined,
          labels: {
            formatter: (val) => {
              if (this.horizontal) {
                return val;
              }

              return this.isScale ? Number(val).toFixed(0) : `${val}%`;
            },
            style: {
              colors: "#94a3b8",
            },
          },
        },

        tooltip: {
          theme: "dark",
          y: {
            formatter: (val, { dataPointIndex }) => {
              if (!this.isScale) {
                return `${val}%`;
              }

              const item = this.data[dataPointIndex];
              const classification = item?.classification?.label || "-";
              const display =
                item?.display || Number(val).toFixed(2).replace(".", ",");

              return `${display} • ${classification}`;
            },
          },
        },

        legend: {
          show: !this.isScale,
          position: "top",
          horizontalAlign: "right",
          labels: {
            colors: "#d1d5db",
          },
        },

        grid: {
          borderColor: "rgba(255,255,255,0.08)",
        },
      };
    },

    dynamicHeight() {
      if (!this.horizontal) return 320;

      const baseHeightPerItem = this.isScale ? 38 : 35;
      return Math.max(this.data.length * baseHeightPerItem, 220);
    },
  },
};
</script>
